export interface NavItem {
  label: string;
  path: string;
}

export const siteNav: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "明星资讯", path: "/news" },
  { label: "影视作品", path: "/works" },
  { label: "明星资料", path: "/profile" },
  { label: "关于我们", path: "/about" },
];

export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  image: string;
  linkType: "news" | "work";
  linkId: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-night",
    title: "《东京夜航》十月定档",
    subtitle: "佐佐木明希首次挑战冷峻女检察官，预告与主视觉正式公开",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20nighttime%20Tokyo%20cityscape%20with%20reflective%20wet%20streets%20and%20soft%20neon%20glow%2C%20moody%20cool%20muted%20neutral%20tones%2C%20atmospheric%20film%20photography%2C%20shallow%20depth%20of%20field%2C%20elegant%20editorial%20mood&width=1920&height=1080&seq=hero-night-01&orientation=landscape",
    linkType: "work",
    linkId: "tokyo-night-flight",
  },
  {
    id: "hero-snow",
    title: "电影《雪之记忆》首映",
    subtitle: "一场穿越雪国的安静旅程，佐佐木明希细腻演绎高桥雪",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20snow%20covered%20winter%20landscape%20with%20a%20lone%20road%20between%20pine%20trees%2C%20soft%20overcast%20light%2C%20muted%20cool%20neutral%20tones%2C%20atmospheric%20film%20photography%2C%20quiet%20and%20serene&width=1920&height=1080&seq=hero-snow-01&orientation=landscape",
    linkType: "work",
    linkId: "memory-of-snow",
  },
  {
    id: "hero-interview",
    title: "专访 · 表演的孤独",
    subtitle: "出道十年，佐佐木明希回顾自己的表演轨迹与心境变化",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20quiet%20warm%20lit%20studio%20room%20with%20a%20single%20chair%20and%20soft%20window%20light%2C%20muted%20warm%20neutral%20tones%2C%20editorial%20film%20photography%2C%20intimate%20and%20calm&width=1920&height=1080&seq=hero-interview-01&orientation=landscape",
    linkType: "news",
    linkId: "news-interview-tenyears",
  },
  {
    id: "hero-coast",
    title: "《寂静海岸》釜山入围",
    subtitle: "克制而富有余韵的表演，让影评人再一次记住了她的名字",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20calm%20sea%20horizon%20at%20dusk%20with%20soft%20overcast%20sky%20and%20gentle%20waves%2C%20muted%20cool%20neutral%20tones%2C%20minimal%20atmospheric%20film%20photography%2C%20serene%20mood&width=1920&height=1080&seq=hero-coast-01&orientation=landscape",
    linkType: "work",
    linkId: "silent-coast",
  },
];

export interface FriendLink {
  name: string;
  url: string;
  desc: string;
}

export const friendLinks: FriendLink[] = [
  { name: "影视资料库", url: "/works", desc: "完整作品与角色档案" },
  { name: "明星资讯中心", url: "/news", desc: "最新动态与深度访谈" },
  { name: "演艺人物志", url: "/profile", desc: "从出道到现在的历程" },
  { name: "影展与活动", url: "/news", desc: "电影节与公开活动记录" },
];

export interface ProfileInfo {
  name: string;
  nameAlt: string;
  roman: string;
  avatar: string;
  quote: string;
  birthday: string;
  birthplace: string;
  height: string;
  debut: string;
  agency: string;
  specialties: string[];
  representativeWorks: string[];
  bio: string[];
}

export const profileInfo: ProfileInfo = {
  name: "佐佐木明希",
  nameAlt: "佐々木 明希",
  roman: "Sasaki Aki",
  avatar:
    "https://readdy.ai/api/search-image?query=refined%20editorial%20portrait%20of%20an%20elegant%20East%20Asian%20woman%20with%20long%20dark%20wavy%20hair%20and%20soft%20natural%20makeup%20in%20a%20beige%20knit%20sweater%2C%20soft%20diffused%20studio%20lighting%2C%20muted%20neutral%20background%2C%20magazine%20cover%20photography%2C%20calm%20graceful%20expression&width=800&height=1000&seq=profile-avatar-01&orientation=portrait",
  quote: "表演是一场需要长期忍受孤独的自我对话，我愿意一直说下去。",
  birthday: "1993 年 4 月 12 日",
  birthplace: "日本 · 神奈川县",
  height: "165 cm",
  debut: "2016 年（舞台剧出道）",
  agency: "青岚艺能事务所",
  specialties: ["文艺片", "悬疑剧", "舞台剧", "声音设计"],
  representativeWorks: ["东京夜航", "雪之记忆", "寂静海岸", "春日邮便"],
  bio: [
    "佐佐木明希，1993 年出生于日本神奈川县，2016 年以舞台剧演员身份正式出道。早期在小型剧场的多年打磨，让她形成了极为克制、注重内在动机的表演风格。",
    "2018 年，她凭借电影《最初的春》首次获得大范围关注；此后接连出演《秋刀鱼的滋味》《玻璃之翼》等作品，逐渐从配角成长为能够独当一面的演员。",
    "2022 年的文艺片《群青》被视为她表演生涯的转折点，影评人称其表演「几乎不需要台词」。2023 年至 2026 年间，她连续主演《春日邮便》《寂静海岸》《雪之记忆》《东京夜航》等多部话题作品，成为同时代最受讨论的演员之一。",
    "除了影视表演，佐佐木明希也持续参与舞台剧与声音作品的创作，并多次担任国际影展评审。她偏爱线条克制、情绪内敛的角色，认为「少说一点，人物反而更完整」。",
  ],
};

export interface AwardItem {
  year: string;
  name: string;
  work: string;
  result: string;
}

export const awards: AwardItem[] = [
  { year: "2026", name: "亚洲电影大奖 · 最佳女主角", work: "雪之记忆", result: "提名" },
  { year: "2025", name: "釜山国际电影节 · 新浪潮单元", work: "寂静海岸", result: "入围" },
  { year: "2024", name: "东京电视剧赏 · 最佳女主角", work: "深夜诊疗室", result: "获奖" },
  { year: "2022", name: "横滨电影节 · 最佳女主角", work: "群青", result: "获奖" },
  { year: "2020", name: "放送文化基金奖 · 表演奖", work: "玻璃之翼", result: "提名" },
];

export interface TimelineItem {
  year: string;
  text: string;
}

export const timeline: TimelineItem[] = [
  { year: "2016", text: "以舞台剧演员身份出道，在小剧场完成超过两百场演出。" },
  { year: "2018", text: "主演电影《最初的春》，首次进入主流视野。" },
  { year: "2020", text: "主演电视剧《玻璃之翼》，展现鲜明的角色塑造力。" },
  { year: "2022", text: "主演文艺片《群青》，获横滨电影节最佳女主角。" },
  { year: "2024", text: "主演《深夜诊疗室》，获东京电视剧赏最佳女主角。" },
  { year: "2026", text: "主演《东京夜航》与《雪之记忆》，迎來作品密集的一年。" },
];

export interface ContactItem {
  icon: string;
  label: string;
  value: string;
}

export const contactItems: ContactItem[] = [
  { icon: "ri-mail-line", label: "官方邮箱", value: "contact@sasakiaki-demo.jp" },
  { icon: "ri-phone-line", label: "媒体联络", value: "+81 3-1234-5678" },
  { icon: "ri-map-pin-line", label: "办公地址", value: "日本 东京都 港区 芝公园 2-1（演示地址）" },
  { icon: "ri-time-line", label: "工作时间", value: "周一至周五 10:00 - 18:00" },
];